import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import autoTable from 'jspdf-autotable';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { FutureGuidesSchoolVO } from 'src/app/shared/models/FutureGuidesSchoolVO';
import { GuidesResponseVO } from 'src/app/shared/models/GuidesResponseVO';
import { LstStoreResponse } from 'src/app/shared/models/lstStoreResponse';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { Store } from 'src/app/shared/models/Store';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { WrksParcipResVO } from 'src/app/shared/models/WrksParcipResVO';
import { WrksResponseVO } from 'src/app/shared/models/WrksResponseVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import * as FileSaver from 'file-saver';
import { IndexType } from 'typescript';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';

@Component({
  selector: 'app-future-guides-schools',
  templateUrl: './future-guides-schools.component.html',
  styleUrls: ['./future-guides-schools.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class FutureGuidesSchoolsComponent implements OnInit {
  //Elementos de traducción inicio.
  lstRespTranslate: TranslateRelLabelVO[];

  lbl_zone: string = "zone_";
  lbl_natio: string = "national_";
  lbl_local: string = "local_";
  lbl_period: string = "period_";
  lbl_select: string = "select_";
  lbl_search: string = "search_";
  lbl_participants: string = "participants_";
  lbl_name: string = "name_";
  lbl_lastName: string = "last_name_";
  lbl_Contact: string = "contact_";
  lbl_stage: string = "stage_";
  lbl_startDate: string = "starting_date_";
  lbl_workshop: string = "workshop_";
  lbl_supervised: string = "supervised_";
  lbl_total: string = "total_";
  lbl_there_are: string = "there_are_";
  lbl_guide_imparts: string = "guide_imparts_";
  lbl_go_Back: string = "back_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_following_up: string = "following_up_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_future_guide: string = "future_guide_";
  lbl_status: string = "status_";
  lbl_comments: string = "comments_";
  lbl_id: string = "id_";
  lbl_starting_date: string = "starting_date_";
  lbl_school: string = "school_";
  lbl_no_valid: string = "is_not_valid_";
  lbl_list: string = "list_";
  lbl_no_records_found: string = "no_records_found_";


  //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  security: SecurityDocument;
  //Elementos de seguridad fin

  listFutureGuides: FutureGuidesSchoolVO[];
  listFutureGuides2: FutureGuidesSchoolVO[];
  listRecords: any[];
  lstGui: GuidesResponseVO[];
  lstWrks: WrksResponseVO[];
  lstPartServ: WrksParcipResVO[]
  listStores: string[] = [];

  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;
  listFGStatus: any[];
  selectedFGStatus: any;

  listZones: Store[];
  selectedZone: Store;
  listNatio: Store[];
  selectedNatio: Store;
  listLocal: Store[];
  selectedLocal: Store;
  blocked: boolean = false;



  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private filesService: TovpilFilesService,
    private tovpilUtils: TovpilUtilsService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
        });
    this.getSecurity();

  }
  search() {
    this.listFutureGuides = [];
    this.listRecords = [];
    this.getValidStores();

  }

  listHstGuides() {
    this.apiService.listHstGuides(

      {
        "guiType": "F",
        "year": this.selectedPeriod.year,
        "period": this.selectedPeriod.period,
        "lstStr": this.listStores
      }
    ).then(
      data => {
        this.lstGui = data;

        for (let ct = 0; ct < this.lstGui.length; ct++) {

          let vo: FutureGuidesSchoolVO = {
            guideId: this.lstGui[ct].guideId,
            name: this.lstGui[ct].name,
            lastName: this.lstGui[ct].lastName,
            localName: this.lstGui[ct].locShrName,
            natioName: this.lstGui[ct].natShrName,
            zoneName: this.lstGui[ct].zonShrName
          };

          this.listFutureGuides.push(vo);
        }
        this.searchWorkShop();

      });
  }
  searchWorkShop() {
    this.apiService.searchWorkShop(
      {
        "guiType": "F",
        "year": this.selectedPeriod.year,
        "period": this.selectedPeriod.period,
        "lstStr": this.listStores
      }
    ).then(
      data => {
        this.lstWrks = data;
        for (let ct = 0; ct < this.lstWrks.length; ct++) {
          var index: number = this.listFutureGuides.indexOf(this.listFutureGuides.find(x => x.guideId == this.lstWrks[ct].guideId));
          if (index >= 0) {
            this.listFutureGuides[index].stage = "III";
            this.listFutureGuides[index].wrksName = this.lstWrks[ct].serName;
            this.listFutureGuides[index].wrksStrDate = this.lstWrks[ct].strDate;
          }
        }
        this.listGuidesPartiInService();
      });


  }
  listGuidesPartiInService() {

    this.apiService.listGuidesPartiInService(
      {
        "lstSerTyp": ["16", "17", "18"],
        "year": this.selectedPeriod.year,
        "period": this.selectedPeriod.period,
        "lstStr": this.listStores
      }
    ).then(
      data => {
        this.lstPartServ = data;
        for (let ct = 0; ct < this.lstPartServ.length; ct++) {
          var index: number = this.listFutureGuides.indexOf(this.listFutureGuides.find(x => x.guideId == this.lstPartServ[ct].partGuideId));
          if (index >= 0) {
            if (this.listFutureGuides[index].stage == null || this.listFutureGuides[index].stage == ' ') {
              if (this.lstPartServ[ct].serTyp == '18') {
                this.listFutureGuides[index].stage = "III";
              } else if (this.lstPartServ[ct].serTyp == '17') {
                this.listFutureGuides[index].stage = "II";
              } else if (this.lstPartServ[ct].serTyp == '16') {
                this.listFutureGuides[index].stage = "I";
              }
              this.listFutureGuides[index].strDate = this.lstPartServ[ct].strDate;
              this.listFutureGuides[index].wrksTeacher = this.lstPartServ[ct].teachName + " " + this.lstPartServ[ct].teachLastName;
              this.listFutureGuides[index].contact = this.lstPartServ[ct].teachEmail + " " + this.lstPartServ[ct].teachMobphon;
            } else {
              if (this.lstPartServ[ct].serTyp == '18' && (this.listFutureGuides[index].strDate == null || this.listFutureGuides[index].strDate == ' ')) {
                this.listFutureGuides[index].strDate = this.lstPartServ[ct].strDate;
                this.listFutureGuides[index].wrksTeacher = this.lstPartServ[ct].teachName + " " + this.lstPartServ[ct].teachLastName;
                this.listFutureGuides[index].contact = this.lstPartServ[ct].teachEmail + " " + this.lstPartServ[ct].teachMobphon;
              }
            }
          }
        }

        this.listFutureGuides2 = this.listFutureGuides;
        this.listFutureGuides = [];
      });

  }
  getValidPeriods() {
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        this.selectedPeriod = this.listPeriods[0];
        this.findSupStoreRelationship();
      });
  }
  listFGInShool(storeId: any) {
    this.blocked = true;
    this.apiService.listFGInShool(
      {
        "storeId": storeId,
        "status": this.selectedFGStatus.valueId
      }
    ).then(
      data => {
        this.listRecords = data;
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error' + error, detail: "loading data", life: 3000 });
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }
  getValidStores() {
    let lstRes: LstStoreResponse;
    let supStoreId: string;
    if (this.selectedLocal != null && this.selectedLocal.storeId != null) {
      supStoreId = this.selectedLocal.storeId;
    } else if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      supStoreId = this.selectedNatio.storeId;
    } else if (this.selectedZone != null && this.selectedZone.storeId != null) {
      supStoreId = this.selectedZone.storeId;
    } else {
      supStoreId = "0000000002";
    }
    this.apiService.getDependetLocalStores(
      {
        "year": this.selectedPeriod.year,
        "period": this.selectedPeriod.period,
        "storeId": supStoreId
      }
    ).then(
      data => {
        this.listStores = data;
        this.listFGInShool(supStoreId);
        //this.listHstGuides();
      });
  }
  getSecurity() {
    this.listZones = [];
    this.listNatio = [];
    this.listLocal = [];
    this.apiService.findSecurityById(
      {
        "id": this.token
      }
    ).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        this.getValidPeriods();

        this.listCategoryFGStatus();
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];

    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_no_records_found, this.lbl_list, this.lbl_no_valid, this.lbl_comments, this.lbl_school, this.lbl_starting_date, this.lbl_id, this.lbl_select, this.lbl_zone, this.lbl_name, this.lbl_natio, this.lbl_local, this.lbl_period, this.lbl_lastName, this.lbl_participants, this.lbl_Contact, this.lbl_stage, this.lbl_startDate, this.lbl_workshop, this.lbl_supervised, this.lbl_search, this.lbl_total, this.lbl_there_are, this.lbl_guide_imparts, this.lbl_go_Back, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_following_up, this.lbl_school_prep_guides, this.lbl_future_guide, this.lbl_status]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_lastName = map.get(this.lbl_lastName);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_local = map.get(this.lbl_local);
        this.lbl_natio = map.get(this.lbl_natio);
        this.lbl_zone = map.get(this.lbl_zone);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_Contact = map.get(this.lbl_Contact);
        this.lbl_stage = map.get(this.lbl_stage);
        this.lbl_startDate = map.get(this.lbl_startDate);
        this.lbl_supervised = map.get(this.lbl_supervised);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_there_are = map.get(this.lbl_there_are);
        this.lbl_guide_imparts = map.get(this.lbl_guide_imparts);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_following_up = map.get(this.lbl_following_up);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_starting_date = map.get(this.lbl_starting_date);
        this.lbl_school = map.get(this.lbl_school);
        this.lbl_no_valid = map.get(this.lbl_no_valid);
        this.lbl_list = map.get(this.lbl_list);
        this.lbl_no_records_found = map.get(this.lbl_no_records_found);
      });
  }
  getChildStores(selStr: string, level: string) {
    let res: LstStoreResponse;
    this.apiService.getListStore(selStr, this.selectedPeriod.year, this.selectedPeriod.period).then(
      data => {
        res = data;
        if (level == 'L') {
          this.listLocal = res.lstStore;
        } else if (level == 'N') {
          this.listNatio = res.lstStore;
        } else if (level == 'Z') {
          if (this.listZones == null || this.listZones.length == 0) {
            this.listZones = res.lstStore;
          }
        }
      });

  }
  loadLocals(event) {

    if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      this.getChildStores(this.selectedNatio.storeId, 'L');
      this.searchNatio();
    }
  }
  loadNatios(event) {
    if (this.selectedZone != null && this.selectedZone.storeId != null) {
      this.getChildStores(this.selectedZone.storeId, 'N');
      this.searchZone();
    }
  }

  datePipe: DatePipe = new DatePipe('en-US');
  /**
     * This function formats a given date string into a specific format using the datePipe module in
     * TypeScript.
     * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
     * "Oct 15, 2021").
     * @returns The function `formatDate` is returning a formatted date string in the format of
     * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
     * format the date. The formatted date string is then returned by the function.
     */
  formatDate(dateString: string) {

    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }

  exportExcel() {
    if (this.listFutureGuides2 === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.lbl_no_records_found,
        life: 3000
      });
    } else if (this.listFutureGuides2.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.lbl_list} ${this.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.listFutureGuides2.map((item) => {
        return {
          "NOMBRE": item.name || 'S/N',
          "APELLIDO": item.lastName || 'S/N',
          "ETAPA": item.stage || 'S/N',
          "FECHA_INICIO": this.formatDate(item.strDate) || 'S/N',
          "NOMBRE_SERVICIO": item.wrksName || 'S/N',
          "FECHA_INICIO_SERVICIO": this.formatDate(item.wrksStrDate) || 'S/N',
          "CONTACTO": item.contact || 'S/N',
          "LOCAL": item.localName || 'S/N',
          "NACIONAL": item.natioName || 'S/N',
          "ZONA": item.zoneName || 'S/N',
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listFutureGuides_');

    }
  }

  exportPdf() {
    if (this.listFutureGuides2 === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.lbl_no_records_found,
        life: 3000
      });
    } else if (this.listFutureGuides2.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.lbl_list} ${this.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.listFutureGuides2.map((item) => {
        return {
          "NOMBRE": item.name || 'S/N',
          "APELLIDO": item.lastName || 'S/N',
          "ETAPA": item.stage || 'S/N',
          "FECHA_INICIO": this.formatDate(item.strDate) || 'S/N',
          "NOMBRE_SERVICIO": item.wrksName || 'S/N',
          "FECHA_INICIO_SERVICIO": this.formatDate(item.wrksStrDate) || 'S/N',
          "CONTACTO": item.contact || 'S/N',
          "LOCAL": item.localName || 'S/N',
          "NACIONAL": item.natioName || 'S/N',
          "ZONA": item.zoneName || 'S/N',
        };
      });


      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listFutureGuides_');

    }
  }
  searchLocal(event) {
    if (this.selectedLocal) {
      // this.listFGInShool(this.selectedLocal.storeId);
    } else if (this.selectedNatio) {
      //this.listFGInShool(this.selectedNatio.storeId);
    }
  }
  searchNatio() {
    if (this.selectedNatio) {
      //this.listFGInShool(this.selectedNatio.storeId);
    } else {

    }
  }
  searchZone() {
    // this.listFGInShool(this.selectedZone.storeId);
  }
  listCategoryFGStatus() {
    this.apiService.listCategoryTranslation({
      "fieldId": "FGStatus",
      "language": this.security.language
    }).then(
      data => {
        this.listFGStatus = data
        if (!this.selectedFGStatus) {
          this.selectedFGStatus = this.listFGStatus[0];
        }
        //this.listFGInShool(this.security.storeId);
      })
  }
  goBack() {
    window.close();
  }
  findSupStoreRelationship() {
    this.apiService.findSupStoreRelationship({
      "storeId": this.security.storeId
    }).then(
      data => {
        if (data) {
          this.selectedLocal = data.strLocal;
          this.selectedNatio = data.strNatio;
          this.selectedZone = data.strZone;

          if (this.security.levelId == 'L') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.listLocal.push(this.selectedLocal);
          } else if (this.security.levelId == 'N') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.getChildStores(this.selectedNatio.storeId, 'L');
          } else if (this.security.levelId == 'Z') {
            this.listZones.push(this.selectedZone);
            this.getChildStores(this.selectedZone.storeId, 'N');
          } else if (this.security.levelId == 'I') {
            this.getChildStores('0000000002', 'Z');
          } else {
          }
        }
      })
  }
}
